export function getAllParentElements(el, limit = 30) {
  const parents = [];
  const numLimit = typeof limit === 'number' ? limit : 30;
  const elLimit = typeof limit === 'object' ? limit : null;
  let counter = 0;
  while (el?.parentElement) {
    if (elLimit === el.parentElement) {
      return parents;
    }
    parents.push(el.parentElement);
    el = el.parentElement;
    counter++;
    if (counter === numLimit) {
      return parents;
    }
  }
  return parents;
}